import { Button } from '@equitymultiple/react-eui';
import { Link } from 'gatsby';
import React, { Dispatch, useEffect, useState } from 'react';

import ArticleCard, {
  Props as ArticleCardProps,
} from '../../../../components/ArticleCard/ArticleCard';
import EmptyState from '../../../../components/EmptyState/EmptyState';
import SvgProjector from '../../../../components/SvgProjector/SvgProjector';
import { Routes } from '../../../../constants/routes';
import { BlogFilter } from '../BlogFilter/BlogFilter';
import { FilterOptions, SearchBarProps } from '../BlogFilter/BlogFilter.types';
import * as styles from './SearchResults.module.scss';

type Props = {
  pageTitle?: string;
  results: Readonly<Queries.WpPost>[];
  query: string;
  searchBarProps?: SearchBarProps;
  setQuery: Dispatch<React.SetStateAction<string>>;
  setInput: Dispatch<React.SetStateAction<string>>;
  defaultExpandedAccordion?: FilterOptions;
  selectedOptionCopy?: string;
};

const hasWindow = typeof window !== 'undefined';

const SearchResults = ({
  results,
  query,
  searchBarProps,
  setQuery,
  setInput,
  defaultExpandedAccordion,
  selectedOptionCopy,
  pageTitle,
}: Props) => {
  const [isntBlogPage, setIsntBlogPage] = useState(false);

  useEffect(() => {
    if (hasWindow) {
      setIsntBlogPage(window.location.pathname !== Routes.blog.url);
    }
  }, []);

  return (
    <div className={styles.searchResults}>
      <div className="container">
        <h1 className={`expressive heading1 ${styles.pageTitle}`}>
          {pageTitle}
        </h1>
      </div>
      <div className="col-md-12 visibleLgOrLesser">
        <BlogFilter
          routeToBlogOnSearch={isntBlogPage}
          searchBarProps={{ ...searchBarProps }}
          defaultExpandedAccordion={defaultExpandedAccordion}
          selectedOptionCopy={selectedOptionCopy}
        />
      </div>
      <div className={`container ${styles.wrapper}`}>
        <div
          className={`row ${
            results.length ? '' : 'justify-content-center align-items-start'
          }`}
        >
          <div className="col-xl-3 visibleXlOrGreater">
            <BlogFilter
              routeToBlogOnSearch={isntBlogPage}
              searchBarProps={{ ...searchBarProps }}
              defaultExpandedAccordion={defaultExpandedAccordion}
              selectedOptionCopy={selectedOptionCopy}
            />
          </div>
          <div className="col-xl-9">
            {results.length ? (
              <div className="row">
                {results.map((post: Queries.BlogPostByIdQuery['post']) => (
                  <div key={post?.id} className="col-md-6 col-xl-3">
                    <ArticleCard
                      blogPostData={
                        { post } as ArticleCardProps['blogPostData']
                      }
                    />
                  </div>
                ))}
              </div>
            ) : (
              <EmptyState
                className={styles.noResultEmptyState}
                data-testid="emptyArticles"
                actionableContent={
                  <Link to={Routes.blog.url}>
                    <Button
                      variant="ghost"
                      leadingIcon="arrowLeft"
                      onClick={() => {
                        setQuery('');
                        setInput('');
                      }}
                    >
                      Back to Articles
                    </Button>
                  </Link>
                }
                centerContent={
                  <SvgProjector fileUrl="images/article-not-found" />
                }
                headingText={`No results for "${query}"`}
                subHeadingText="Try searching for a different term, navigate using the filters, or connect with us and we will address your questions in depth."
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchResults;
